export default __webpack_public_path__ + "static/media/newsimplan-icon-tc.ae7a0664.png";